import { atom, selector } from 'recoil'
import type { BleedWarningInfo } from '@/hooks/editor/useAllPagesBleedCheck'

/**
 * Stores all bleed warning results from the all-pages check.
 * Updated by useAllPagesBleedCheck hook.
 */
export const bleedWarningsAtom = atom<BleedWarningInfo[]>({
  key: 'bleedWarnings',
  default: [],
})

/**
 * Controls visibility of the bleed warning modal.
 * Set to true when user clicks Back and there are bleed warnings.
 */
export const showBleedWarningModalAtom = atom<boolean>({
  key: 'showBleedWarningModal',
  default: false,
})

/**
 * Selector to check if there are any active bleed warnings.
 */
export const hasBleedWarningsSelector = selector<boolean>({
  key: 'hasBleedWarnings',
  get: ({ get }) => {
    const warnings = get(bleedWarningsAtom)
    return warnings.length > 0
  },
})

/**
 * Tracks whether the initial bleed check has completed.
 * This prevents showing stale warnings when the check hasn't finished
 * (e.g., after fixing an item but before the debounced check completes).
 * Similar to initialImageQualityCheckCompletedAtom for PPI checks.
 */
export const bleedCheckCompletedAtom = atom<boolean>({
  key: 'bleedCheckCompleted',
  default: false,
})
